import { handleActions } from 'redux-actions';

const initialState = {
  isProcessing: false,
  failure: false,
  data: [],
};

export default handleActions(
  {
    'FAQ/REQUEST': (state, action) => {
      return Object.assign({}, state, {
        isProcessing: true,
      });
    },
    'FAQ/SUCCESS': (state, action) => {
      return Object.assign({}, state, {
        isProcessing: false,
        failure: false,
        data: action.payload.data,
      });
    },
    'FAQ/FAILURE': (state, action) => {
      return Object.assign({}, state, {
        isProcessing: false,
        failure: true,
      });
    },
  },
  initialState
);